var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCreditCardVisa = function SvgCreditCardVisa(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("title", null, "credit-card-visa"), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.75,
    y: 3.75,
    width: 22.5,
    height: 16.5,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.75,
    y1: 15,
    x2: 9.75,
    y2: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.75,9v2.037A7.488,7.488,0,0,0,5.25,15a7.488,7.488,0,0,0,1.5-3.963V9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.4,9H13.2A1.2,1.2,0,0,0,12,10.2c0,1.8,2.4,1.8,2.4,3.6A1.2,1.2,0,0,1,13.2,15H12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 17.25,
    y1: 12.75,
    x2: 20.25,
    y2: 12.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.25,15V10.5a1.5,1.5,0,0,0-3,0V15"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCardVisa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "credit-card-visa.ecbb1c443b00d6f0e0e1152fafe87e96.svg";